import {
  Modal,
  TextAreaInput,
  TextInput,
  InputSelect,
} from '@wajeez-web/components/ui';
import React, { useEffect, useState } from 'react';
import { CommonModalProps } from './Types';
export type TemplateCategoryType = {
  templateCategoryId: string;
  title: string;
  description: string;
};
interface TemplateModalProps
  extends CommonModalProps<{
    title: string;
    description: string;
    templateCategoryId: string;
  }> {
  templateCategories: TemplateCategoryType[] | undefined;
}

const TemplateModal: React.FC<TemplateModalProps> = ({
  isOpen,
  onClose,
  onSubmit,
  templateCategories,
  data,
}) => {
  const [values, setValues] = useState<TemplateCategoryType>({
    templateCategoryId: '',
    title: '',
    description: '',
  });
  const areas = templateCategories?.map((templateCategory) => {
    return {
      label: templateCategory.title,
      value: templateCategory.templateCategoryId,
    };
  });

  useEffect(() => {
    if (data) {
      data && setValues(data);
    }
    return () => {
      setValues({ templateCategoryId: '', title: '', description: '' });
    };
  }, [data]);

  const onChange = (name: string, value: string) => {
    setValues({ ...values, [name]: value });
  };
  return (
    <Modal
      title={'Create Template'}
      open={isOpen}
      onClose={onClose}
      onSubmit={() => onSubmit && onSubmit(values)}
    >
      <div className="space-y-2">
        <TextInput
          label="Title"
          name="title"
          value={values.title}
          onChange={onChange}
          required={true}
        />

        <TextAreaInput
          label="Description"
          name="description"
          value={values.description}
          onChange={onChange}
          required={true}
        />

        <InputSelect
          name="templateCategoryId"
          label="Template Category"
          required={true}
          options={areas || []}
          value={areas?.find(
            (item) => item.value === values.templateCategoryId
          )}
          onChange={(name, value: any) => {
            setValues({ ...values, templateCategoryId: value.value });
          }}
        />
      </div>
    </Modal>
  );
};

export default TemplateModal;
